import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {User} from '../models/user';
import {Observable, of, throwError} from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import {ApiResponse} from '../models/api.response';


@Injectable()
export class SpiUtils {

  constructor() { }

  clone(obj: any) {
    let copy;

    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
    //Handle Date object
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.clone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) {
          copy[attr] = this.clone(obj[attr]);
        }
      }
      return copy;
    }

    throw new Error('Unable to copy obj! Its type isn\'t supported.');
  }

  getDefinedStringValue(){}
  getDistinctArrayVals(){}
  validateJson(){}
  warningMessage(){}
  infoMessage(){}
  errorMessage(){}
  successMessage(){}
  onSuccessNotify(){}
  onErrorNotify(){}
  confirmAction(){}
  simpleConfirmAction(){}
  openDialogInfo(){}
  isDefined(obj: any) {
    return obj !== undefined && obj !== null && obj !== 'null' && obj !== '' && typeof obj !== 'undefined';
  }
  formatSQLCode(){}
  replaceAll(){}
  compareJSONRecursive(){}

}
